<nav class="bg-white border-gray-200 dark:bg-gray-900 fixed top-0 left-0 right-0 z-50">
    <div class="flex flex-wrap items-center justify-between w-full p-4">
      <div class="flex items-center space-x-3">
        @if (showSidebar) {
          <button
            (click)="toggleMobileSidebar()"
            type="button"
            class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
            <span class="sr-only">Toggle sidebar</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
            </svg>
          </button>
        }
        <div class="relative group">
          <a href="https://blazebite.com/" class="flex items-center space-x-3 rtl:space-x-reverse">
            <img src="assets/blazebite-logo.png" class="h-8" alt="Blazebite Logo" />
          </a>
          <!-- Build info popover; pt-2 bridges the hover gap so the card stays open -->
          <div class="hidden group-hover:block absolute left-0 top-full z-50 pt-2">
            <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg px-4 py-3 text-xs whitespace-nowrap">
              <div class="text-gray-500 dark:text-gray-400">{{ environment }}</div>
              @if (version.sha) {
                <a
                  [href]="'https://github.com/Blazebite/blazebite-super-admin/commit/' + version.sha"
                  target="_blank"
                  rel="noopener"
                  class="font-mono text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white underline">
                  build {{ version.shortSha }}
                </a>
              } @else {
                <span class="font-mono text-gray-700 dark:text-gray-300">build {{ version.shortSha }}</span>
              }
              @if (builtAtUtc) {
                <div class="text-gray-500 dark:text-gray-400 mt-0.5">{{ builtAtUtc }}</div>
              }
            </div>
          </div>
        </div>
      </div>
      <app-secondary-nav></app-secondary-nav>
    </div>
  </nav>

  <!-- Mobile sidebar overlay -->
  @if (showSidebar && isMobileSidebarOpen) {
    <div
      (click)="toggleMobileSidebar()"
      class="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
      style="margin-top: 72px;">
    </div>
  }

  <div class="flex pt-[72px]">
    @if (showSidebar) {
      <app-sidebar [isMobileOpen]="isMobileSidebarOpen"></app-sidebar>
    }
    <div class="flex-grow min-w-0 transition-all duration-300" [ngClass]="{ 'lg:ml-80': showSidebar }">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Support assistant: only rendered inside the logged-in shell -->
  <app-chat-button class="print:hidden"></app-chat-button>
  <!-- Lookup FAB: venue + user search from any page, stacked above the assistant -->
  <app-lookup-button class="print:hidden"></app-lookup-button>
  <!-- Super Admin User panel: hosted here (not in the nav) so its backdrop sits above the fixed nav and FABs -->
  <app-super-admin-user-dialog [isOpen]="userDialog.isOpen()" (close)="userDialog.close()"></app-super-admin-user-dialog>
